import React from "react";
import {
  Box,
  Typography,
  Grid,
  Button,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import ContentHeader from "../ContentHeader/ContentHeader";
import LoanCardCarousel from "../carouselComponent/loanCardCarouselComponent";

const loanAmounts = [
  "₹15,000",
  "₹16,000",
  "₹18,000",
  "₹19,000",
  "₹21,000",
  "₹22,000",
  "₹23,000",
  "₹24,000",
  "₹25,000",
  "₹27,000",
  "₹28,000",
  "₹30,000",
];

const SalaryLoanSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box sx={{ p: { xs: 2, md: 8 }, backgroundColor: { xs: "#fff", md: "#F1FFF0" } }}>
      <ContentHeader
        heading={"Turn Your Salary Into Instant Cash"}
        paragraph={"Quick personal loans based on your monthly income"}
      />

      <LoanCardCarousel amounts={loanAmounts}/>
        
    </Box>
  );
};

export default SalaryLoanSection;
